import React from 'react';
import {Button} from 'iss/widgets/Buttons';
import styles from 'iss/styles/ActivationList.styl';
import {translate} from 'iss/strings';

export const SortOrderEnum = Object.freeze({
  ASCENDING: 'ASC',
  DESCENDING: 'DESC'
});

export function SortColumnHeader({text, field, onChangeSort}) {
  return <div className={styles.header}>
    <span className={styles.title}>{translate(text)}</span>
    <div className={styles.buttons}>
      <Button id={"sortASC-" + field} className={styles.button} size="xs" icon="arrow-up" alt="" onClick={() => onChangeSort(field, SortOrderEnum.ASCENDING)} />
      <Button id={"sortDESC-" + field} className={styles.button} size="xs" icon="arrow-down" alt="" onClick={() => onChangeSort(field, SortOrderEnum.DESCENDING)} />
    </div>
  </div>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/SortColumnHeader.jsx